import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import BrandButton from 'components/BrandButton';
import Link from 'components/Link';
import cn from './styles.local.less';

export default class SecondaryPromo extends PureComponent {
  static propTypes = {
    content: PropTypes.string,
    contentMobile: PropTypes.string,
    imageSource: PropTypes.string,
    linkSource: PropTypes.string,
    linkTitle: PropTypes.string,
    linkTitleMobile: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const {
      linkSource,
      linkTitle,
      linkTitleMobile,
      content,
      contentMobile,
      imageSource,
      title,
      onClick,
    } = this.props;

    if (!linkSource) {
      return null;
    }

    return (
      <Link
        to={linkSource}
        onClick={onClick}
        data-qa-selector="promo"
        className={cn.root}
        style={{ backgroundImage: `url(${imageSource})` }}
      >
        <div className={cn.main}>
          <div className={cn.content}>
            <div className={cn.title}>{title}</div>
            <p className={cn.contentBody}>
              <span className="hidden-xs">{content}</span>
              <span className="visible-xs">{contentMobile}</span>
            </p>

            <footer className={cn.footer}>
              <BrandButton className={cn.link}>
                <span className="hidden-xs">{linkTitle}</span>
                <span className="visible-xs">{linkTitleMobile}</span>
              </BrandButton>
            </footer>
          </div>
        </div>
      </Link>
    );
  }
}
